import {RouteDefinition} from "../../../routes"
import { AuthorizationGroupAddUser } from "./AuthorizationGroupAddUser"
import {AuthorizationGroupScreen} from "./AuthorizationGroupEdit"
import {AuthorizationGroupList} from "./AuthorizationGroupList"
import {AuthorizationUserList} from "./AuthorizationGroupUserList"

export const AuthorityGroupRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/authority",
        component: AuthorizationGroupList
    },
    {
        routerLink: "/settings/authority/edit",
        component: AuthorizationGroupScreen
    },
    {
        routerLink: "/settings/authority/edit/:id",
        component: AuthorizationGroupScreen
    },
    {
        routerLink: "/settings/authority/user-list",
        component: AuthorizationUserList
    },
    {
        routerLink: "/settings/authority/add-user/:id",
        component: AuthorizationGroupAddUser
    }
]
